import React, { useEffect, useState } from 'react'
import CustomDatePicker from '../../components/shared/CustomDatePicker'
import { CButton, CRow, CCol, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem, CFormLabel, CNav, CNavItem, CNavLink, CTabContent, CTabPane } from '@coreui/react'
import fetchPatientData from '../../services/general/patientGeneralAPI.api'
import PatientInsurance from './PatientInsurance'
import PatientInsuranceFn from '../../services/general/PatientInsuranceAPI.api'
import Appointment from './Appointment'
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars'

const ManualScheduling = ({ providers, notSchedule, checkedPatients, locations, findDates, daysMap, setManual, handleManualSchedule, callManual, Manual, setVisible, setPatientDate, setActiveTab, setLoader, allData, setCheckedPatients, appointments }) => {
  const [accordionState, setAccordionState] = useState([])
  const [insuranceList, setInsuranceList] = useState([])
  const [insuranceTypes, setInsuranceTypes] = useState([])
  const [selectedInsuranceDetails, setSelectedInsuranceDetails] = useState({})
  const [addedInsurances, setAddedInsurances] = useState([])
  const [activeNav, setActiveNav] = useState('appointment')
  const [selectedPatient, setSelectedPatient] = useState(null)
  const [activeTabs, setActiveTabs] = useState({})
  const [accordionInsuranceDetails, setAccordionInsuranceDetails] = useState({})

  const updateActiveTab = (index, tab) => {
    setActiveTabs((prev) => ({ ...prev, [index]: tab }))
  }

  const handleSubmit = () => {
    setManual(accordionState)
  }
  const getData = async () => {
    let insuranceData = await fetchPatientData('GET', 'Insurance', '{}')
    insuranceData = JSON.parse(insuranceData.d)?.Data
    const uniqueInsuranceTypes = Array.from(new Set(insuranceData.map((ins) => ins.Type)))
    setInsuranceList(insuranceData)
    setInsuranceTypes(uniqueInsuranceTypes)
  }

  // const selectPatientFn = async (e) => {
  //     setSelectedPatient(e);

  //     let selectedPatient = e;

  //     let oldAppointments = appointments.filter((item) => item.current.Patient.value === selectedPatient.PatientID)
  //     //  if(oldAppointments.length > 0)
  //     //  {
  //     //     let newAppointments = oldAppointments.at(-1)
  //     //     setAccordionState([])
  //     //  }
  //     let patient = {};
  //     let insurances = [];
  //     let isAuth = false;
  //     if (selectedPatient) {
  //         let patientInsurance = await PatientInsuranceFn("SELECT", "", selectedPatient.PatientID);
  //         try {
  //             patientInsurance = JSON.parse(patientInsurance.d)?.Data;

  //             // if (patientInsurance?.InsuranceDetails) {
  //             //     patientInsurance = {
  //             //         ...patientInsurance,
  //             //         InsuranceDetails: JSON.parse(patientInsurance?.InsuranceDetails)
  //             //     }
  //             // }
  //             // patientInsurance = patientInsurance.map((item) => [...item, { InsuranceDetails: JSON.parse(InsuranceDetails) }])

  //         } catch (e) { }

  //         setSelectedInsuranceDetails({ Insurances: patientInsurance })
  //         // setAddedInsurances(patientInsurance)
  //     }

  //     let validIDs = [6, 7, 8, 12, 13];
  //     try {
  //         insurances.find(ins => {
  //             if (ins.InsuranceID === 6 || ins.InsuranceID === 7 || ins.InsuranceID === 8 || ins.InsuranceID === 12 || ins.InsuranceID === 13) {
  //                 isAuth = true;
  //                 return true; // Return true to stop the search early once a match is found
  //             }
  //             return false;
  //         });
  //         // setModalVisible(true); // Set modal visible state to true

  //     } catch (e) {
  //         console.error("Error occurred while checking insurance IDs:", e);
  //     }

  //     let patientInsurance = localStorage.getItem("PatientInsurance");

  // };

  const selectPatientFn = async (patient, accordionIndex = null) => {
    setSelectedPatient(patient)

    let selectedPatient = patient

    let oldAppointments = appointments.filter((item) => item.current.Patient.value === selectedPatient.PatientID)

    let insurances = []
    let isAuth = false

    if (selectedPatient) {
      let patientInsurance = await PatientInsuranceFn('SELECT', '', selectedPatient.PatientID)
      try {
        patientInsurance = JSON.parse(patientInsurance.d)?.Data
      } catch (e) {}

      // Store insurance details per accordion index instead of globally
      if (accordionIndex !== null) {
        setAccordionInsuranceDetails((prev) => ({
          ...prev,
          [accordionIndex]: { Insurances: patientInsurance },
        }))
      } else {
        // Fallback for global usage if needed
        setSelectedInsuranceDetails({ Insurances: patientInsurance })
      }
    }

    let validIDs = [6, 7, 8, 12, 13]
    try {
      insurances.find((ins) => {
        if (ins.InsuranceID === 6 || ins.InsuranceID === 7 || ins.InsuranceID === 8 || ins.InsuranceID === 12 || ins.InsuranceID === 13) {
          isAuth = true
          return true
        }
        return false
      })
    } catch (e) {
      console.error('Error occurred while checking insurance IDs:', e)
    }

    let patientInsurance = localStorage.getItem('PatientInsurance')
  }

  const handlePriorAuthDetailsChange = (e) => {
    const { name, value } = e.target
    setPriorAuthDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }))
  }

  useEffect(() => {
    getData()
  }, [])
  useEffect(() => {
    if (Manual.length > 0) {
      handleManualSchedule()
    }
  }, [Manual])

  useEffect(() => {
    const defaultTabs = {}
    notSchedule.forEach((_, index) => {
      defaultTabs[index] = 'appointment'
    })
    setActiveTabs(defaultTabs)
  }, [notSchedule])

  return (
    <>
      <div className="mt-4 shadow-md" style={{ height: '420px', overflow: 'auto' }}>
        <CAccordion className="non-accordion-collapse ">
          {notSchedule
            ?.filter((item) => checkedPatients.includes(item.PatientID))
            .map((patient, i) => {
              const updateAccordionState = (index, field, value) => {
                setAccordionState((prevState) => {
                  const newState = [...prevState]
                  newState[index] = { ...newState[index], [field]: value }
                  return newState
                })
              }

              if (!accordionState[i]) {
                setAccordionState((prevState) => {
                  const newState = [...prevState]
                  while (newState.length <= i) {
                    newState.push({ selectedDate: null, selectedProvider: null })
                  }
                  return newState
                })
              }

              let facilityDays = locations?.filter((facility) => facility.Name === patient.FacilityName)[0]

              let allowedDates = findDates(facilityDays?.Days.split(',') || [])

              if (accordionState[i]?.patient === undefined) {
                updateAccordionState(i, 'patient', patient)
              }
              return (
                <CAccordionItem itemKey={i} key={patient.PatientID} onMouseDown={(e) => e.stopPropagation()} style={{ marginTop: '10px', borderRadius: '3px' }} className="border bg-light">
                  <CAccordionHeader onMouseDown={(e) => e.stopPropagation()}>{`${patient?.FirstName} ${patient?.LastName} (${patient?.FacilityName})`}</CAccordionHeader>
                  <CAccordionBody>
                    <div style={{ height: '325px', overflow: 'auto' }}>
                      <CNav variant="pills" role="tablist" className="justify-content-center ">
                        <CNavItem className="bg-light">
                          <CNavLink active={activeTabs[i] === 'appointment'} onClick={() => updateActiveTab(i, 'appointment')} className="bg-light">
                            Appointment Details
                          </CNavLink>
                        </CNavItem>
                        {/* <CNavItem>
                                                    <CNavLink
                                                        active={activeTabs[i] === 'insurance'}
                                                        onClick={() => {
                                                            updateActiveTab(i, 'insurance');
                                                            selectPatientFn(patient);
                                                            
                                                        }}
                                                        className="bg-light"
                                                    >
                                                        Insurance Detailsw
                                                    </CNavLink>
                                                </CNavItem> */}
                        <CNavItem>
                          <CNavLink
                            active={activeTabs[i] === 'insurance'}
                            onClick={() => {
                              updateActiveTab(i, 'insurance')
                              selectPatientFn(patient, i) // Pass accordion index
                            }}
                            className="bg-light"
                          >
                            Insurance Details
                          </CNavLink>
                        </CNavItem>
                        <CNavItem>
                          <CNavLink active={activeTabs[i] === 'question'} onClick={() => updateActiveTab(i, 'question')} className="bg-light">
                            Other Details
                          </CNavLink>
                        </CNavItem>
                      </CNav>

                      <CTabContent>
                        <CTabPane role="tabpanel" visible={activeTabs[i] === 'appointment'}>
                          <div className="mx-5 mt-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                            <CustomDatePicker
                              allowedDates={allowedDates}
                              providers={providers}
                              daysMap={daysMap}
                              locations={locations}
                              selectedDate={accordionState[i]?.selectedDate}
                              selectedProvider={accordionState[i]?.selectedProvider}
                              onDateChange={(date) => updateAccordionState(i, 'selectedDate', date)}
                              onProviderChange={(provider) => updateAccordionState(i, 'selectedProvider', provider)}
                              facilityDays={facilityDays}
                              isInFacility={(isInFacility) => updateAccordionState(i, 'isFacility', isInFacility)}
                              selectedIsInFacility={accordionState[i]?.isFacility}
                            />
                          </div>
                        </CTabPane>
                        {/* <CTabPane role="tabpanel" visible={activeTabs[i] === 'insurance'}>
                                                    <div className='mx-5 mt-4'>
                                                        <PatientInsurance allData={allData} Credentialed={"hidden"} addedInsurances={addedInsurances} setAddedInsurances={setAddedInsurances} selectedDetails={selectedInsuranceDetails} insuranceList={insuranceList} insuranceTypes={insuranceTypes} setActiveTab={setActiveTab} index={i} updateAccordionState={updateAccordionState} patientId={patient.PatientID} />
                                                    </div>
                                                </CTabPane> */}

                        <CTabPane role="tabpanel" visible={activeTabs[i] === 'insurance'}>
                          <div className="mx-5 mt-4">
                            <PatientInsurance
                              allData={allData}
                              Credentialed={'hidden'}
                              addedInsurances={addedInsurances}
                              setAddedInsurances={setAddedInsurances}
                              selectedDetails={accordionInsuranceDetails[i]} // Use accordion-specific data
                              insuranceList={insuranceList}
                              insuranceTypes={insuranceTypes}
                              setActiveTab={setActiveTab}
                              index={i}
                              updateAccordionState={updateAccordionState}
                              patientId={patient.PatientID}
                            />
                          </div>
                        </CTabPane>

                        <CTabPane role="tabpanel" visible={activeTabs[i] === 'question'}>
                          <div className="mx-5 mt-4">
                            <div className="form-check mb-3 d-flex align-items-center gap-2">
                              <input
                                type="checkbox"
                                id="priorAuthCheckbox"
                                className="form-check-input"
                                checked={accordionState[i]?.otherDetails?.priorAuth?.isRequired || false}
                                onChange={(e) => {
                                  updateAccordionState(i, 'otherDetails', {
                                    ...accordionState[i]?.otherDetails,
                                    priorAuth: {
                                      ...accordionState[i]?.otherDetails?.priorAuth,
                                      isRequired: e.target.checked,
                                    },
                                  })
                                }}
                              />
                              <label htmlFor="priorAuthCheckbox" className="form-check-label mt-1">
                                Does Need Prior Auth?
                              </label>
                            </div>

                            {accordionState[i]?.otherDetails?.priorAuth?.isRequired && (
                              <div className="border p-3 mb-3 bg-white">
                                <div className="mb-2">
                                  <label htmlFor="priorAuthNo" className="form-label">
                                    Prior Auth No:
                                  </label>
                                  <input
                                    type="text"
                                    id="priorAuthNo"
                                    name="priorAuthNo"
                                    className="form-control"
                                    value={accordionState[i]?.otherDetails?.priorAuth?.details?.priorAuthNo || ''}
                                    placeholder="Enter Prior Auth No"
                                    onChange={(e) => {
                                      updateAccordionState(i, 'otherDetails', {
                                        ...accordionState[i]?.otherDetails,
                                        priorAuth: {
                                          ...accordionState[i]?.otherDetails?.priorAuth,
                                          details: {
                                            ...accordionState[i]?.otherDetails?.priorAuth?.details,
                                            priorAuthNo: e.target.value,
                                          },
                                        },
                                      })
                                    }}
                                  />
                                </div>
                                {/* <div className="mb-2">
                                                                    <label htmlFor="expDate" className="form-label">
                                                                        Expiration Date:
                                                                    </label>
                                                                    <input
                                                                        type="date"
                                                                        id="expDate"
                                                                        name="expDate"
                                                                        className="form-control"
                                                                        value={accordionState[i]?.otherDetails?.priorAuth?.details?.expDate || ''}
                                                                        onChange={(e) => {
                                                                            updateAccordionState(i, "otherDetails", {
                                                                                ...accordionState[i]?.otherDetails,
                                                                                priorAuth: {
                                                                                    ...accordionState[i]?.otherDetails?.priorAuth,
                                                                                    details: {
                                                                                        ...accordionState[i]?.otherDetails?.priorAuth?.details,
                                                                                        expDate: e.target.value
                                                                                    }
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                </div> */}
                                <div className="mb-2">
                                  <label htmlFor={`expDate-${i}`} className="form-label">
                                    Expiration Date:
                                  </label>
                                  <DateTimePickerComponent
                                    id={`expDate-${i}`}
                                    name="expDate"
                                    format="MM/dd/yyyy"
                                    value={accordionState[i]?.otherDetails?.priorAuth?.details?.expDate ? new Date(accordionState[i].otherDetails.priorAuth.details.expDate) : null}
                                    className="form-control"
                                    change={(e) => {
                                      const selectedDate = e?.value

                                      updateAccordionState(i, 'otherDetails', {
                                        ...accordionState[i]?.otherDetails,
                                        priorAuth: {
                                          ...accordionState[i]?.otherDetails?.priorAuth,
                                          details: {
                                            ...accordionState[i]?.otherDetails?.priorAuth?.details,
                                            expDate: selectedDate?.toISOString(), // Or toLocaleDateString('en-US') if you want MM/DD/YYYY
                                          },
                                        },
                                      })
                                    }}
                                  />
                                </div>

                                <div>
                                  <label htmlFor="noOfTimes" className="form-label">
                                    No. of Times:
                                  </label>
                                  <input
                                    type="number"
                                    id="noOfTimes"
                                    name="noOfTimes"
                                    className="form-control"
                                    value={accordionState[i]?.otherDetails?.priorAuth?.details?.noOfTimes || ''}
                                    placeholder="Enter No. of Times"
                                    onChange={(e) => {
                                      updateAccordionState(i, 'otherDetails', {
                                        ...accordionState[i]?.otherDetails,
                                        priorAuth: {
                                          ...accordionState[i]?.otherDetails?.priorAuth,
                                          details: {
                                            ...accordionState[i]?.otherDetails?.priorAuth?.details,
                                            noOfTimes: e.target.value,
                                          },
                                        },
                                      })
                                    }}
                                  />
                                </div>
                              </div>
                            )}

                            <div className="form-check mb-3 mt-1">
                              <input
                                type="checkbox"
                                id="coSignCheckbox"
                                className="form-check-input"
                                checked={accordionState[i]?.otherDetails?.isCoSignRequired || false}
                                onChange={(e) => {
                                  updateAccordionState(i, 'otherDetails', {
                                    ...accordionState[i]?.otherDetails,
                                    isCoSignRequired: e.target.checked,
                                  })
                                }}
                              />
                              <label htmlFor="coSignCheckbox" className="form-check-label">
                                Co-sign Required.
                              </label>
                            </div>

                            {/* <div className="form-check mb-3 mt-1">
                                                            <input
                                                                type="checkbox"
                                                                id="patientFacilityCheckbox"
                                                                className="form-check-input"
                                                                checked={accordionState[i]?.otherDetails?.isPatientInFacility || false}
                                                                onChange={(e) => {
                                                                    updateAccordionState(i, "otherDetails", {
                                                                        ...accordionState[i]?.otherDetails,
                                                                        isPatientInFacility: e.target.checked
                                                                    });
                                                                }}
                                                            />
                                                            <label htmlFor="patientFacilityCheckbox" className="form-check-label">
                                                                Is Patient in Facility?
                                                            </label>
                                                        </div> */}
                          </div>
                        </CTabPane>
                      </CTabContent>
                    </div>
                  </CAccordionBody>
                </CAccordionItem>
              )
            })}
        </CAccordion>
      </div>
      <hr />
      <div className="mt-4 d-flex  gap-2 justify-content-end">
        <CButton
          variant="outline"
          color="secondary"
          onClick={() => {
            ;(setVisible(false), setPatientDate([]), setActiveTab(0), setManual([]), setCheckedPatients([]))
          }}
        >
          {' '}
          Cancel
        </CButton>
        <CButton
          variant="outline"
          onClick={() => {
            handleSubmit()
          }}
        >
          {' '}
          Schedule
        </CButton>
      </div>
    </>
  )
}

export default ManualScheduling
